import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { firebaseConfigStaging, firebaseConfigProd } from '../config/configs';

const firebaseConfig =
  process.env.REACT_APP_ENV === 'production'
    ? firebaseConfigProd
    : firebaseConfigStaging;

// Initialize Firebase
const firebase = initializeApp(firebaseConfig);

export const firestore = getFirestore(firebase);

export const auth = getAuth(firebase);
